<template>
    <div class="container">
        <div class="currentImage">
            <span class="discount-badge" v-if="discount > 0">
                    {{discount}}%
            </span>
            <img class="img-fluid" :src="currentImage" v-if="currentImage !== null"/>
        </div>
        <div class="row" v-if="images_.length > 1">
            <div class="col-sm-12 col-md-3 p-2 cursor-pointer" v-for="(image, index) in images_" :key="index" @click="setCurrent(image)">
                <img class="img-thumbnail" :src="image"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {__clone} from "../../helpers";

    export default {
        name: "ProductGallery",
        props: {
            data: Array,
            discount: Number
        },

        created() {
            this.bootstrap();
        },

        data() {
            return {
                current: null,
                images: []
            }
        },

        methods: {
            bootstrap() {
                let data = __clone(this.data);
                this.current = data[0];
                this.images = data;
            },

            setCurrent(image) {
                this.current = image;
            }
        },

        computed: {

            currentImage() {
                return this.current;
            },

            images_() {
                return this.images;
            }
        },

        'watch': {
            'data': {
                immediate: true,
                handler() {
                    this.bootstrap();
                }
            }
        }
    }
</script>

<style scoped>
    .cursor-pointer {
        cursor: pointer;
    }

    .discount-badge {
        position: absolute;
        right: 10px;
        top: 10px;
        background: #b89453 !important;
        color: white;
        text-align: center;
        border-radius: 30px 30px 30px 30px;
        padding: 5px 10px;
        font-size: 20px;
        z-index: 10;
    }

    .currentImage {
        min-height:430px;
    }
</style>
